import React, { useState, useEffect } from 'react';
import './CollapsibleWidget.css';

interface CollapsibleWidgetProps {
  title: string;
  defaultExpanded?: boolean;
  storageKey?: string; // Optional key for localStorage persistence
  children: React.ReactNode;
}

const CollapsibleWidget: React.FC<CollapsibleWidgetProps> = ({
  title,
  defaultExpanded = true,
  storageKey,
  children,
}) => {
  // Initialize expanded state from localStorage or default
  const [isExpanded, setIsExpanded] = useState(() => {
    if (storageKey) {
      const stored = localStorage.getItem(`widget-expanded-${storageKey}`);
      if (stored !== null) {
        return stored === 'true';
      }
    }
    return defaultExpanded;
  });

  // Update localStorage when expanded state changes
  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(`widget-expanded-${storageKey}`, String(isExpanded));
    }
  }, [isExpanded, storageKey]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-widget ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <button
        type="button"
        className="collapsible-widget__header"
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <span className="collapsible-widget__title">{title}</span>
        <span className={`collapsible-widget__chevron ${isExpanded ? 'expanded' : ''}`}>
          ▼
        </span>
      </button>
      <div className="collapsible-widget__content-wrapper">
        <div className="collapsible-widget__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleWidget;
